import { auth } from '@/firebase';
import { ReconnectingEventSource } from '@/api/ReconnectingEventSource';

const URL = 'https://us-central1-mesh-db-stg.cloudfunctions.net/device';
const URLStream = 'https://api.meshcommengineering.com/api/v1/';

class Device {
    static async get(path='', token=null) {
        // Handle regular REST API requests
        const response = await fetch(`${URL}${path}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
        });

        return response.json();
    }

    static async post(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });

        return response.json();
    }

    static async put(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
            },
            body: body,
        });
        return response.json();
    }

    static async delete(path='', body, token=null) {
        const response = await fetch(`${URL}${path}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token || await auth.currentUser.getIdToken()}`,
                'Content-Type': 'application/json',
            },
            body: body,
        });
        return response.json();
    }

    static async stream(dataID='', token=null) {
        const url = dataID
            ? `${URLStream}stream/devices?dataID=${encodeURIComponent(dataID)}`
            : `${URLStream}stream/devices`;

        // Refresh the Firebase ID token on every (re)connect so long-lived
        // streams don't die with 401s after the original token expires
        // (~1 hour). When an explicit token is provided (e.g. from a Web
        // Worker that has no access to `auth`), we reuse it verbatim.
        const getHeaders = async () => {
            const authToken = token || await auth.currentUser.getIdToken();
            return { Authorization: `Bearer ${authToken}` };
        };

        return new ReconnectingEventSource(url, { getHeaders });
    }
}

export default Device;